module.exports = {
	config: {
		isCacheable: false
	},
	model: {
		nav: {}
	},
	methods: {
		prepare: function(storage){

			const NAV_CODE = 'main';
			// activate menu entry
			let activeRoute = [], i, activeLangCode = '';
			// or by parent routes in breadcrumbs
			for (i in storage.request.breadCrumbs) {
				if (storage.request.breadCrumbs[i].subType==="page") {
					activeRoute.push(storage.request.breadCrumbs[i].routeID);
					if (activeLangCode === '') activeLangCode = storage.request.breadCrumbs[i].model.lang;
				}
			}

			let ignoreDate = false;
			let data = [];
			const curTime = new Date().getTime();
			let c, r, isVisible, rtPeriodStart, rtPeriodEnd;

			let status = (((storage || {}).user || {}).data || {}).visibleStatus || {
				'active': 			true,
				'preview & active': true
			};
			if (status.preview){
				ignoreDate = true;
			}

			if (this.resourceData.data) {
				for (c in this.resourceData.data) {
					if (this.resourceData.data[c].attributes.value === NAV_CODE) {
						for (r in this.resourceData.data[c].children.cms_routes.data) {
							// status is correct
							isVisible = status[this.resourceData.data[c].children.cms_routes.data[r].attributes.status];
							// check period
							if (!ignoreDate) {
								rtPeriodStart = this.resourceData.data[c].children.cms_routes.data[r].attributes.periodStart;
								if (rtPeriodStart !== null) {
									rtPeriodStart = new Date(rtPeriodStart).getTime();
									if (curTime < rtPeriodStart) isVisible = false;
								}
								rtPeriodEnd = this.resourceData.data[c].children.cms_routes.data[r].attributes.periodEnd;
								if (rtPeriodEnd !== null) {
									rtPeriodEnd = new Date(rtPeriodEnd).getTime();
									if (curTime > rtPeriodEnd) isVisible = false;
								}
							}
							if (isVisible) data.push(this.resourceData.data[c].children.cms_routes.data[r]);
						}
					}
				}
			}

			// build main nav-left
			let rt, target, linkURL, nav = {}, navIndexLookup = {}, routeID, key;
			if (data.length) {
				for (i=0; i<data.length; i++) {
					rt = data[i].attributes;
					if (activeLangCode === rt.langCode) {
						target	= '';
						linkURL = rt.path;
						if (rt.optExternalURL) {
							target	= ' target="_blank" rel="noopener"';
							linkURL = rt.optExternalURL;
						}
						if (rt.optForward301URL) {
							linkURL = rt.optForward301URL;
						}
						rt.linkURL = linkURL;
						rt.linkTargetHTML = target;
						rt.highlightEntry = activeRoute.indexOf(rt.routeID)!==-1;
						rt.level = data[i].level;
						rt.children = [];
						rt.index_key = i + '_' + rt.routeID;
						navIndexLookup[rt.routeID] = rt.index_key;
						nav[rt.index_key] = rt;
					}
				}
				for (key in nav) {
					rt = nav[key];
					if (rt.level > 1 && navIndexLookup[rt.parentRouteID]) {
						nav[navIndexLookup[rt.parentRouteID]].children[nav[navIndexLookup[rt.parentRouteID]].children.length] = nav[key];
					}
				}
				for (key in nav) {
					if (nav[key].level > 1) {
						delete nav[key];
					}
				}
				this.model.nav = nav;
			}
		}
	}
}
